export default class Money {
  static displayGratuityInDollarOrPercentage = (gratuity, percentage = false) => {
    if (percentage) {
      return gratuity
    }
    return parseFloat(gratuity / 100).toFixed(2)
  }

  static gratuityToInteger = (gratuity) => {
    return parseFloat(gratuity) * 100
  }
 }
